const types = {
  DISPLAY: 'app/dialog/DISPLAY',
  HIDE: 'app/dialog/HIDE',
};

export default types;
